import { render, staticRenderFns } from "./FormatDialog.vue?vue&type=template&id=324d795c&scoped=true&"
import script from "./FormatDialog.vue?vue&type=script&lang=js&"
export * from "./FormatDialog.vue?vue&type=script&lang=js&"
import style0 from "./FormatDialog.vue?vue&type=style&index=0&id=324d795c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324d795c",
  null
  
)

export default component.exports